export default "__VITE_ASSET__DBVyKtXM__"